<template>
    <li :disabled="disabled">
        <router-link v-if="url" :to="url" @click.native="handleClick">
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
        </router-link>
        <a v-else-if="href" :href="href" :target="target">
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
        </a>
        <a v-else href="javascript:;" @click.prevent="handleClick">
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`"></i> {{ label }}
        </a>
    </li>
</template>

<script>
export default {
    methods: {
        handleClick() {
            $(this.$el).closest('.dropdown-menu').trigger('hide.bs.dropdown')
            this.$emit('click', this.$event)
        },
    },
    props: { 
        disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
        href: {
            type: String,
			required: false,
			default: null,
        },
        icon: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        target: {
            type: String,
            required: false,
            default: '_blank',
        },
        url: {
            type: String,
            required: false,
            default: null,
        },
    }
}
</script>